import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import error from '../../../assets/images/error.png';
import {Header} from '../header';

/*
 * Props.
 */

export interface FullScreenErrorProps {
  description: ReactNode;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: grid;
  align-content: center;
  align-items: center;
`;

const StyledImage = styled.img`
  width: 100%;
  margin-top: -40px;
`;

const StyledDescriptionDiv = styled.div`
  margin-top: 8px;
  max-width: 50%;
`;

/*
 * Component.
 */

export const FullScreenError: FC<FullScreenErrorProps> = (props) => (
  <StyledWrapperDiv>
    <Header>Oops!</Header>
    <StyledDescriptionDiv>{props.description}</StyledDescriptionDiv>
    <StyledImage src={error} />
  </StyledWrapperDiv>
);
